import './LegalNotice.css';

export const COMPLAINTS_EMAIL = 'complains@hotmate.ai';

export default function LegalNotice({ className = '' }) {
    return (
        <div className={`legalNotice ${className}`.trim()}>
            <p>
                This website is operated by Hotmate Ltd, Giannou Kranidioti &amp; Pargas, 9, office 102, Nicosia, 1065, Cyprus.
            </p>
            <p>
                If you have any complaints or concerns, you may contact us at <a href={`mailto:${COMPLAINTS_EMAIL}`}>{COMPLAINTS_EMAIL}</a>. Any submission will receive a response and be resolved within a reasonable timeframe, typically within 7 business days.
            </p>
        </div>
    );
}
